jQuery(document).ready(function ($) {
    var content = $('.InnerSlider--video_content');
    var video = $('video');


    $.each(video, function (i) {

        video[i].addEventListener('playing', function () {
            content.fadeOut();
            $('.video_card-overlay').css({"display": "none"});
            $('.video-button_wrapper').css({"display": "none"});
            $('.mejs-controls').addClass("control");

        });
        video[i].addEventListener('pause', function () {
            content.fadeIn();
            $('.video_card-overlay').css({"display": "block"});
            $('.video-button_wrapper').css({"display": "block"});
            $('.mejs-controls').removeClass("control");

        });
    });

    function close_accordion_section() {
        $('.accordion-section-title').removeClass('active');
        $('.accordion-section-content').slideUp(0).removeClass('open');
    }

    var FistChildB = $('.before:first>a');
    var FistChildA = $('.after:first>a');
    var currentAttrValueA = $(FistChildA).attr('href');
    var currentAttrValueB = $(FistChildB).attr('href');


    $(FistChildA).addClass("active");


    $(".after_btn").click(function () {
        $(this).addClass("InnerSlider-btn-is_active");
        $('.before_btn').removeClass("InnerSlider-btn-is_active");
        $('.before').css({"display": "none"});
        $('.after').css({"display": "block"});
        if ($('.accordion-section-title').is('.active')) {
            close_accordion_section();
        } else {
            close_accordion_section();
        }
        $(FistChildA).removeClass("active");
        FistChildA.addClass('active');
        $('.accordion ' + currentAttrValueA).slideDown(0).addClass('open');


    });
    $(".before_btn").click(function () {
        $(this).addClass("InnerSlider-btn-is_active");
        $('.after_btn').removeClass("InnerSlider-btn-is_active");
        $('.before').css({"display": "block"});
        $('.after').css({"display": "none"});
        if ($('.accordion-section-title').is('.active')) {
            close_accordion_section();
        } else {
            close_accordion_section();
        }


        $('.tab-0').removeClass("active");
        FistChildB.addClass('active');

        $('.accordion ' + currentAttrValueB).slideDown(0).addClass('open');

    });


    $('.accordion-section-title').click(function (e) {
        // Grab current anchor value

        var currentAttrValue = $(this).attr('href');

        if ($(e.target).is('.active')) {
            close_accordion_section();
        } else {
            close_accordion_section();

            // Add active class to section title
            $(this).addClass('active');

            // Open up the hidden content panel
            $('.accordion ' + currentAttrValue).slideDown(0).addClass('open');
        }

        e.preventDefault();
    });


    var rev = $('.rev_slider');
    var current = $('.slick-slide');
    rev.on('init', function (event, slick, currentSlide) {
        var cur = $(slick.$slides[slick.currentSlide]), next = cur.next(), next2 = cur.next().next(), prev = cur.prev(),
            prev2 = cur.prev().prev();
        // prev.addClass('slick-sprev');
        next.addClass('slick-snext');
        next2.addClass('slick-snext2');
        cur.removeClass('slick-snext').removeClass('slick-sprev').removeClass('slick-snext2').removeClass('slick-sprev2');
        // slick.$prev = prev;
        slick.$next = next;
        // prev.removeClass('animation_remove');
        next.removeClass('animation_remove');
        // prev2.removeClass('animation_remove');
        next2.removeClass('animation_remove');
        cur.removeClass('animation_remove');

    }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {


        var cur = $(slick.$slides[nextSlide]);

        // console.log(slick.$prev, slick.$next);
        // slick.$prev.removeClass('slick-sprev');
        slick.$next.removeClass('slick-snext');
        // slick.$prev.prev().removeClass('slick-sprev2');
        slick.$next.next().removeClass('slick-snext2');
        next = cur.next();
        prev = cur.prev();

        //prev2.prev().prev();
        // next2.next().next();
        // prev.addClass('slick-sprev');
        next.addClass('slick-snext');

        // prev.prev().addClass('slick-sprev2');
        next.next().addClass('slick-snext2');
        slick.$prev = prev;
        slick.$next = next;

        // prev.removeClass('animation_remove');
        next.removeClass('animation_remove');

        // prev.prev().removeClass('animation_remove');
        // next.next().removeClass('animation_remove');

        cur.removeClass('slick-next').removeClass('slick-sprev').removeClass('slick-next2').removeClass('slick-sprev2');

        $('.slick-current').css('animation', 'fade-in 0.4s');
   
        next.find('video').each(function () {
            $(this).get(0).pause();
        });
        prev.find('video').each(function () {
            $(this).get(0).pause();
        });

        prev.prev().find('video').each(function () {
            $(this).get(0).pause();
        });
        next.next().find('video').each(function () {
            $(this).get(0).pause();
        });

    });

    rev.slick({
        speed: 500,
        arrows: true,
        focusOnSelect: true,
        prevArrow: $('.prev_arrow'),
        nextArrow: $('.next_arrow'),
        infinite: true,
        centerMode: true,
        slidesPerRow: 1,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerPadding: '0',
        swipe: true,

    });

    let open = document.querySelector('.StvHeader-navbar_open_icon');
    let menu = document.querySelector('.nav-main');
    let navbar = document.getElementById('StvHeader-navbar_icon');
    $('.menu-item a').click(function () {
        var SliderId = $(this).attr('href');
        console.log("SliderId: "+SliderId);
        var SlideIndex = $(SliderId).data('slick-index');
        rev.slick('slickGoTo', SlideIndex);
        menu.classList.toggle('StvHeader-nav_main--close');
        open.classList.toggle('StvHeader-navbar_open_icon--nodisplay');
        navbar.style.display = 'none';
        navbar.style.display = 'flex';
    });


    FLBuilder.registerModuleHelper('map', {

        init: function () {
            var form = $('.fl-builder-settings'), address = form.find('textarea[name=address]'),
                height = form.find('input[name=height_responsive]');

            address.on('input', this._previewAddress);
            height.on('input', this._previewResponsiveHeight);
        },

        _previewAddress: function () {
            var form = $('.fl-builder-settings'), address = form.find('textarea[name=address]').val(),
                q = '' === address ? 'United Kingdom' : address,
                url = 'https://www.google.com/maps/embed/v1/place?key=AIzaSyD09zQ9PNDNNy9TadMuzRV_UsPUoWKntt8&q=',
                iframe = $(FLBuilder.preview.classes.node + ' iframe');

            iframe.attr('src', url + q);
        },

        _previewResponsiveHeight: function () {
            var form = $('.fl-builder-settings'), height = form.find('input[name=height]').val(),
                wrapper = $(FLBuilder.preview.classes.node + ' .fl-map');

            if (isNaN(height)) {
                wrapper.removeClass('fl-map-auto-responsive-disabled');
            } else {
                wrapper.addClass('fl-map-auto-responsive-disabled');
            }
        },
    });
    $(function () {
        $('.fl-map').on('click', function () {
            $(this).find('iframe').css('pointer-events', 'auto');
        });
    });


});